// Зонд перерисовок (VITE_RENDER_PROBE=1, docs/perf-rerenders/MEASURE.md) — до react-dom; без флага его нет в бандле.
import '@srm/ui/lib/renderProbeBoot';
// ВАЖНО: только .layer.css (обёрнуты в @layer mantine). Нелайеренные styles.css
// в prod-билде перекрывают пользовательские .rf-modal__* и т. п. (EUPDEV-12157).
// Лайеринг по докам Mantine — «всё или ничего», см. также ModalLoadingOverlay (nprogress).
// Порядок слоёв (reset<mantine<app) пиннится статикой — см. public/css-layers.css.
import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@mantine/dropzone/styles.layer.css';
import '@srm/ui/lib/dayjs';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BASE_PATH } from '@/configuration';
import App from '@/App';
import SupportSessionGate from '@/components/auth/SupportSessionGate/SupportSessionGate';
import ScreenShareProvider from '@providers/ScreenShareProvider/ScreenShareProvider';
import { isSupportSession } from '@/auth/supportSession';
import { Provider } from 'react-redux';
import { setupStore } from './store';
import { setGenericToastAudience } from './http/index';
import { startAuth } from '@/auth/startAuth';
import { BrowserRouter } from 'react-router';
import { analyticsManager, AnalyticsProvider, initializeAnalytics, PageViewTracker } from '@/analytics';
import { initErrorHandlers } from '@/errorHandling';
import { listenHistoryTraversal } from '@srm/ui/lib/navigationGuard';
import { AppErrorBoundary } from '@/errorHandling/errorBoundaries/CustomErrorBoundary';
import { AppMantineProvider } from '@providers/AppMantineProvider/AppMantineProvider';
import { AppUiProvider } from '@providers/AppUiProvider/AppUiProvider';
import { registerActionExecutors } from '@organisms/actions/registerActionExecutors';
// FormBuilder регистрируется для вложенных форм (NestedFormBuilder) при загрузке своего модуля
import '@molecules/formbuilder/FormBuilder';

// Инициализация обработчиков ошибок
initErrorHandlers();
// «Назад»/«Вперёд» при несохранённых правках: слушатель — раньше роутера (см. listenHistoryTraversal)
listenHistoryTraversal();

registerActionExecutors();

// Инициализация Redux стора
const store = setupStore();
// На PROD общий тост отказа запроса — только администраторам.
setGenericToastAudience(store);

// Инициализация аналитики. Во вкладке «от имени» её нет: просмотры сотрудника не должны попасть
// в статистику пользователя.
const supportTab = isSupportSession();
if (!supportTab) initializeAnalytics();

// Скрываем окно с предложением установить плагин CryptoPRO
window.cadesplugin_skip_extension_install = true;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Монтирование — после запуска сессии (startAuth ждёт тихую ротацию); его отказ — в консоль, а не белый экран.
const authStarted = Promise.resolve()
    .then(() => startAuth(store))
    .catch((error: unknown) => console.error(error));
void authStarted.finally(() => {
    root.render(
        <StrictMode>
            <AppErrorBoundary>
                <AppMantineProvider>
                    <Provider store={store}>
                        <BrowserRouter basename={BASE_PATH}>
                            <AppUiProvider>
                                <AnalyticsProvider analytics={analyticsManager}>
                                    <SupportSessionGate>
                                        <ScreenShareProvider>
                                            {!supportTab && <PageViewTracker />}
                                            <App />
                                        </ScreenShareProvider>
                                    </SupportSessionGate>
                                </AnalyticsProvider>
                            </AppUiProvider>
                        </BrowserRouter>
                    </Provider>
                </AppMantineProvider>
            </AppErrorBoundary>
        </StrictMode>,
    );
});
